// --- React
import React from "react";
// --- Styles
import "./styles.scss";

/**
 * ItemCard Component
 *
 * A simple card wrapper for displaying grouped content items.
 * Used in view drawers for windows, tiers, catalogs, etc.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - Content to display inside the card
 * @param {string} [props.className] - Additional CSS class names
 * @returns {JSX.Element}
 *
 * @example
 * <ItemCard>
 *   <DetailRow label="Name" value={item.name} />
 *   <DetailRow label="Status" value={item.status} />
 * </ItemCard>
 */
export const ItemCard = ({ children, className = "" }) => {
  const classNames = ["item-card", className].filter(Boolean).join(" ");
  return <div className={classNames}>{children}</div>;
};

export default ItemCard;
